import React, { FunctionComponent } from 'react';
import { PromoSection } from '../promo-section/promo-section';
import { CircleFeatureCard } from '../circle-feature-card/circle-feature-card';
import { EmployeeBox } from '../employee-box/employee-box';
import { OurTeam } from '../our-team/our-team';
import { ImgTitleDescriptionComponent } from '../img-title-description/img-title-description';
import { CarouselComponent } from '../carousel/carousel';
import { ItemsInRowComponent } from '../items-in-row/items-in-row';
import { ThreeColumnGrid } from '../three-column-grid/three-column-gird';
import { FourColumnGrid } from '../four-column-grid/four-column-grid';
import { EmployeeCollection } from '../employee-collection/employee-collection';
import { ContactBox } from '../contact-box/contact-box';
import { Button } from '../button/button';
import { Text } from '../text/text';
import { ImageWithText } from '../image-with-text/image-with-text';
import { Models } from '../../models';
import { Chapter } from '../chapter/chapter';
import { KENTICO_TYPES } from '../../const/common/kentico';
import { PageSection } from '../page-section/page-section';
import { ImageFeatureWithLink } from '../image-feature-with-link/image-feature-with-link';
import { TextFeatureWithDescription } from '../text-feature-with-description/text-feature-with-description';
import { BlogArticlesList } from '../blog/blog-articles-list/blog-articles-list';
import { HeroWithVideo } from '../hero-with-video/hero-with-video';
import { Office } from '../office/office';
import { Opinion } from '../opinion/opinion';
import { TabsMenu } from '../tabs-menu/tabs-menu';
import { ArchLineSection } from '../arch-line-section/arch-line-section';
import { QuoteWithImage } from '../quote-with-image/quote-with-image';
import { ProgressSteps } from '../progress-steps/progress-steps';
import { Grid } from '../grid/grid';
import { AwardWithStarsAndImage } from '../award-with-stars-and-image/award-with-stars-and-image';
import { ImageWithButton } from '../image-with-button/image-with-button';
import { Accordion } from '../accordion/accordion';
import { LatestArticles } from '../latest-articles/latest-articles';
import { SocialMediaPanel } from '../social-media-panel/social-media-panel';
import { OurTeamPhotosLink } from '../our-team-photos-link/our-team-photos-link';
import { ProcessIcons } from '../process-icons/process-icons';
import { StaticPageJumbotron } from '../static-page-jumbotron/static-page-jumbotron';
import { IconWithTextSection } from '../icon-with-text-section/icon-with-text-section';
import { SectionHeader } from '../section-header/section-header';
import { MainHero } from '../main-hero/main-hero';
import { TwoColumnGrid } from '../two-columns-grid/two-column-grid';
import { LinkBox } from '../link-box/link-box';
import { CaseStudyList } from '../case-study-list/case-study-list';
import { IconHeader } from '../icon-header/icon-header';
import { ArticleParagraph } from '../article-paragraph/article-paragraph';
import { SideNavSlider } from '../side-nav-slider/side-nav-slider';
import { TextBlockSchema } from '../text-block-schema/text-block-schema';
import { Quote } from '../quote/quote';
import { ContactEmployee } from '../contact-employee/contact-employee';
import { CaseStudyNext } from '../case-study-next/case-study-next';
import { LatestCaseStudies } from '../latest-case-studies/latest-case-studies';
import { BlogHero } from '../blog/blog-hero/blog-hero';
import { FeaturedArticles } from '../blog/featured-articles/featured-articles';
import { TwoColorSectionWithImage } from '../two-color-section-with-image/two-color-section-with-image';
import { DownloadWithImage } from '../download-with-image/download-with-image';
import { TextWithImageOutside } from '../text-with-image-outside/text-with-image-outside';
import { BlogAuthorList } from '../blog/blog-author-list/blog-author-list';
import { IAuthorData } from '../../utils/authorsDataResolver';
import { PageBackLink } from '../page-back-link/page-back-link';
import { IconWithDescription } from '../icon-with-description/icon-with-description';
import { Award } from '../award/award';
import { ActiveJobOfferts } from '../active-job-offerts/active-job-offerts';
import { ProcessBoxes } from '../process-boxes/process-boxes';
import { StickySectionsWrapper } from '../sticky-sections-wrapper/sticky-sections-wrapper';
import { TextEmailButtonForm } from '../form/text-email-button-form/text-email-button-form';
import { VideoList } from '../video-list/video-list';
import { ContactForm } from '../form/contact-form/contact-form';
import { ICaseStudyCategories } from '../../templates/case-studies-page';
import { CTAButton } from '../cta-button/cta-button';
import { HighlightedField } from '../highlighted-field/highlighted-field';
import { EmbeddedVideo } from '../embededded-video/embededded-video';
import { IElevatoListItem } from '../../templates/page';

interface ILinkedItemProps {
  linkedItem: IKontentItem;
  articles?: {
    featured: IKontentItem[];
    notFeatured: IKontentItem[];
  };
  latestArticles?: IBlogArticle[];
  caseStudies?: ICaseStudyData;
  nextCaseStudy?: ICaseStudyNext;
  allAuthors?: boolean;
  authors?: IAuthorData[];
  caseStudyCategories?: ICaseStudyCategories;
  jobOffersElevato?: IElevatoListItem[];
}

const Section: FunctionComponent<ILinkedItemProps> = ({
  linkedItem,
  articles,
  latestArticles,
  caseStudies,
  nextCaseStudy,
  allAuthors,
  authors,
  caseStudyCategories,
  jobOffersElevato = []
}) => {
  let modeledData;
  const typeComponent = linkedItem.system
    ? linkedItem.system.type || null
    : null;
  switch (typeComponent) {
    case KENTICO_TYPES.PROMO_SECTION:
      modeledData = Models.PromoSectionModel.create(
        linkedItem as IPromoSection
      );
      return <PromoSection {...modeledData} />;
    case KENTICO_TYPES.CIRCLE_FEATURE_CARD:
      modeledData = Models.CircleFeatureModel.create(
        linkedItem as ICircleFeatureCard
      );
      return <CircleFeatureCard {...modeledData} />;
    case KENTICO_TYPES.TEXT_EMAIL_BUTTON_FORM:
      modeledData = Models.TextEmailButtonFormModel.create(
        linkedItem as ITextEmailButtonForm
      );
      return <TextEmailButtonForm {...modeledData} />;
    case KENTICO_TYPES.STICKY_SECTIONS_WRAPPER:
      modeledData = Models.StickySectionsWrapperModel.create(
        linkedItem as IStickySectionsWrapper
      );
      return <StickySectionsWrapper {...modeledData} />;
    case KENTICO_TYPES.EMPLOYEE_BOX:
      modeledData = Models.EmployeeBoxModel.create(linkedItem as IEmployeeBox);
      return <EmployeeBox {...modeledData} />;
    case KENTICO_TYPES.FORM_COMPONENT:
      modeledData = Models.FormComponentModel.create(
        linkedItem as IFormComponent
      );
      return <ContactForm {...modeledData} />;
    case KENTICO_TYPES.OUR_TEAM:
      modeledData = Models.OurTeamModel.create(linkedItem as IOurTeam);
      return <OurTeam {...modeledData} />;
    case KENTICO_TYPES.IMAGE_TITLE_DESCRIPTION:
      modeledData = Models.ImageTitleDescriptionModel.create(
        linkedItem as IImageTitleDescription
      );
      return <ImgTitleDescriptionComponent {...modeledData} />;
    case KENTICO_TYPES.BLOG_ARTICLES_LIST:
      modeledData = Models.BlogArticlesListModel.create({
        ...linkedItem,
        ...articles
      } as IBlogArticlesList);
      return <BlogArticlesList {...modeledData} />;

    case KENTICO_TYPES.CASE_STUDY_LIST:
      modeledData = Models.CaseStudyListModel.create({
        ...linkedItem,
        ...caseStudies
      } as ICaseStudyList);
      return (
        <CaseStudyList
          {...modeledData}
          caseStudyCategories={caseStudyCategories}
        />
      );

    case KENTICO_TYPES.CAROUSEL_OF_ITEMS:
      modeledData = Models.CarouselOfItemsModel.create(
        linkedItem as ICarouselOfItems
      );
      return <CarouselComponent {...modeledData} />;
    case KENTICO_TYPES.CAROUSEL_OF_IMAGES:
      modeledData = Models.CarouselOfImagesModel.create(
        linkedItem as ICarouselOfImages
      );
      return <CarouselComponent {...modeledData} />;
    case KENTICO_TYPES.ITEMS_IN_ROW:
      modeledData = Models.ItemsInRowModel.create(linkedItem as IItemsInRow);
      return <ItemsInRowComponent {...modeledData} />;
    case KENTICO_TYPES.CONTACT:
      modeledData = Models.ContactModel.create(linkedItem as IContactBox);
      return <ContactBox {...modeledData} />;
    case KENTICO_TYPES.EMPLOYEES_COLLECTION:
      modeledData = Models.EmployeesCollectionModel.create(
        linkedItem as IEmployeesCollection
      );
      return <EmployeeCollection {...modeledData} />;
    case KENTICO_TYPES.TWO_COLUMN_GRID:
      modeledData = Models.TwoColumnGridModel.create(
        linkedItem as ITwoColumnGrid
      );
      return <TwoColumnGrid {...modeledData} />;
    case KENTICO_TYPES.THREE_COLUMN_GRID:
      modeledData = Models.ThreeColumnGridModel.create(
        linkedItem as IThreeColumnGrid
      );
      return <ThreeColumnGrid {...modeledData} />;
    case KENTICO_TYPES.FOUR_COLUMN_GRID:
      modeledData = Models.FourGridColumnModel.create(
        linkedItem as IFourColumnGrid
      );
      return <FourColumnGrid {...modeledData} />;
    case KENTICO_TYPES.BUTTON:
      modeledData = Models.ButtonModel.create(linkedItem as IButton);
      return <Button {...modeledData} />;
    case KENTICO_TYPES.TEXT:
      modeledData = Models.TextModel.create(linkedItem as IText);
      return <Text {...modeledData} />;
    case KENTICO_TYPES.IMAGE_WITH_TEXT:
      modeledData = Models.ImageWithTextModel.create(linkedItem as IText);
      return <ImageWithText {...modeledData} />;
    case KENTICO_TYPES.PAGE_SECTION:
      modeledData = Models.PageSectionModel.create(linkedItem as IPageSection);
      return (
        <PageSection {...modeledData} jobOffersElevato={jobOffersElevato} />
      );
    case KENTICO_TYPES.IMAGE_WITH_LINK:
      modeledData = Models.ImageFeatureWithLink.create(
        linkedItem as IImageFeatureWithLink
      );
      return <ImageFeatureWithLink {...modeledData} />;
    case KENTICO_TYPES.TEXT_FEATURE_WITH_DESCRIPTION:
      modeledData = Models.TextFeatureWithDescription.create(
        linkedItem as ITextFeatureWithDescription
      );
      return <TextFeatureWithDescription {...modeledData} />;
    case KENTICO_TYPES.HERO_WITH_VIDEO:
      modeledData = Models.HeroWithVideoModel.create(
        linkedItem as IHeroWithVideo
      );
      return <HeroWithVideo {...modeledData} />;
    case KENTICO_TYPES.OFFICE:
      modeledData = Models.OfficeModel.create(linkedItem as IOffice);
      return <Office {...modeledData} />;
    case KENTICO_TYPES.OPINION:
      modeledData = Models.OpinionModel.create(linkedItem as IOpinion);
      return <Opinion {...modeledData} />;
    case KENTICO_TYPES.TABS_MENU:
      modeledData = Models.TabsMenuModel.create(linkedItem as ITabsMenu);
      return <TabsMenu {...modeledData} />;
    case KENTICO_TYPES.ARCH_LINE_SECTION:
      modeledData = Models.ArchLineSectionModel.create(
        linkedItem as IArchLineSection
      );
      return <ArchLineSection {...modeledData} />;
    case KENTICO_TYPES.QUOTE_WITH_IMAGE:
      modeledData = Models.QuoteWithImageModel.create(
        linkedItem as IQuoteWithImage
      );
      return <QuoteWithImage {...modeledData} />;
    case KENTICO_TYPES.PROGRESS_STEPS:
      modeledData = Models.ProgressStepsModel.create(
        linkedItem as IProgressSteps
      );
      return <ProgressSteps {...modeledData} />;
    case KENTICO_TYPES.GRID:
      modeledData = Models.GridModel.create(linkedItem as IGrid);
      return <Grid {...modeledData} />;
    case KENTICO_TYPES.AWARD_WITH_STARS_AND_IMAGE:
      modeledData = Models.AwardWithStarsAndImageModel.create(
        linkedItem as IAwardWithStarsAndImage
      );
      return <AwardWithStarsAndImage {...modeledData} />;
    case KENTICO_TYPES.IMAGE_WITH_BUTTON:
      modeledData = Models.ImageWithButtonModel.create(
        linkedItem as IImageWithButton
      );
      return <ImageWithButton {...modeledData} />;
    case KENTICO_TYPES.ACCORDION:
      modeledData = Models.AccordionModel.create(linkedItem as IAccordion);
      return <Accordion {...modeledData} />;
    case KENTICO_TYPES.LATEST_ARTICLES:
      modeledData = Models.LatestArticlesModel.create({
        ...(linkedItem as ILatestArticles),
        latestArticles: latestArticles
      } as ILatestArticles);
      return <LatestArticles {...modeledData} />;
    case KENTICO_TYPES.SOCIAL_MEDIA_PANEL:
      modeledData = Models.SocialMediaPanelModel.create(
        linkedItem as ISocialMediaPanel
      );
      return <SocialMediaPanel {...modeledData} />;
    case KENTICO_TYPES.OUR_TEAM_PHOTOS_LINK:
      modeledData = Models.OurTeamPhotosLinkModel.create(
        linkedItem as IOurTeamPhotosLink
      );
      return <OurTeamPhotosLink {...modeledData} />;
    case KENTICO_TYPES.PROCESS_ICONS:
      modeledData = Models.ProcessIconsModel.create(
        linkedItem as IProcessIcons
      );
      return <ProcessIcons {...modeledData} />;
    case KENTICO_TYPES.STATIC_PAGE_JUMBOTRON:
      modeledData = Models.StaticPageJumbotronModel.create(
        linkedItem as IStaticPageJumbotron
      );
      return <StaticPageJumbotron {...modeledData} />;
    case KENTICO_TYPES.ICON_WITH_TEXT_SECTION:
      modeledData = Models.IconWithTextSectionModel.create(
        linkedItem as IIconWithTextSection
      );
      return <IconWithTextSection {...modeledData} />;
    case KENTICO_TYPES.SECTION_HEADER:
      modeledData = Models.SectionHeaderModel.create(
        linkedItem as ISectionHeader
      );
      return <SectionHeader {...modeledData} />;
    case KENTICO_TYPES.MAIN_HERO:
      modeledData = Models.MainHeroModel.create(linkedItem as IMainHero);
      return <MainHero {...modeledData} />;
    case KENTICO_TYPES.LINK_BOX:
      modeledData = Models.LinkBoxModel.create(linkedItem as ILinkBox);
      return <LinkBox {...modeledData} />;
    case KENTICO_TYPES.ICON_HEADER:
      modeledData = Models.IconHeaderModel.create(linkedItem as IIconHeader);
      return <IconHeader {...modeledData} />;
    case KENTICO_TYPES.ICON_WITH_DESCRIPTION:
      modeledData = Models.IconWithDescriptionModel.create(
        linkedItem as IIconWithDescription
      );
      return <IconWithDescription {...modeledData} />;
    case KENTICO_TYPES.ARTICLE_PARAGRAPH:
      modeledData = Models.ArticleParagraphModel.create(
        linkedItem as IArticleParagraph
      );
      return <ArticleParagraph {...modeledData} />;
    case KENTICO_TYPES.SIDE_NAV_SLIDER:
      modeledData = Models.SideNavSliderModel.create(
        linkedItem as ISideNavSlider
      );
      return <SideNavSlider {...modeledData} />;
    case KENTICO_TYPES.TEXT_BLOCK_SCHEMA:
      modeledData = Models.TextBlockSchemaModel.create(
        linkedItem as ITextBlockSchema
      );
      return <TextBlockSchema {...modeledData} />;
    case KENTICO_TYPES.CHAPTER:
      modeledData = Models.ChapterModel.create(linkedItem as IChapter);
      return <Chapter {...modeledData} />;
    case KENTICO_TYPES.QUOTE:
      modeledData = Models.QuoteModel.create(linkedItem as IQuote);
      return <Quote {...modeledData} />;
    case KENTICO_TYPES.CONTACT_EMPLOYEE:
      modeledData = Models.ContactEmployeeModel.create(
        linkedItem as IContactEmployee
      );
      return <ContactEmployee {...modeledData} />;
    case KENTICO_TYPES.CASE_STUDY_NEXT:
      let data;
      if (linkedItem.elements.case_study.value.length === 0) {
        data = nextCaseStudy;
      } else {
        data = linkedItem.elements.case_study.value[0];
      }

      modeledData = Models.CaseStudyNextModel.create(data as ICaseStudyNext);
      return <CaseStudyNext {...modeledData} />;
    case KENTICO_TYPES.LATEST_CASE_STUDIES:
      modeledData = Models.LatestCaseStudiesModel.create(
        linkedItem as ILatestCaseStudies
      );
      return <LatestCaseStudies {...modeledData} />;
    case KENTICO_TYPES.BLOG_HERO:
      modeledData = Models.BlogHeroModel.create(linkedItem as IBlogHero);
      return <BlogHero {...modeledData} />;
    case KENTICO_TYPES.FEATURED_ARTICLES:
      modeledData = Models.FeaturedArticlesModel.create({
        ...linkedItem,
        ...articles
      } as IFeaturedArticles);
      return <FeaturedArticles {...modeledData} />;
    case KENTICO_TYPES.TWO_COLOR_SECTION_WITH_IMAGE:
      modeledData = Models.TwoColorSectionWithImageModel.create(
        linkedItem as ITwoColorSectionWithImage
      );
      return <TwoColorSectionWithImage {...modeledData} />;
    case KENTICO_TYPES.DOWNLOAD_WITH_IMAGE:
      modeledData = Models.DownloadWithImageModel.create(
        linkedItem as IDownloadWithImage
      );
      return <DownloadWithImage {...modeledData} />;
    case KENTICO_TYPES.TEXT_WITH_IMAGE_OUTSIDE:
      modeledData = Models.TextWithImageOutsideModel.create(
        linkedItem as ITextWithImageOutside
      );
      return <TextWithImageOutside {...modeledData} />;
    case KENTICO_TYPES.BLOG_AUTHOR_LIST:
      modeledData = Models.BlogAuthorListModel.create(
        linkedItem as IBlogAuthorList
      );
      return (
        <BlogAuthorList
          {...modeledData}
          authors={authors}
          showAllAuthors={allAuthors}
        />
      );
    case KENTICO_TYPES.PAGE_BACK_LINK:
      modeledData = Models.PageBackLinkModel.create(
        linkedItem as IPageBackLink
      );
      return <PageBackLink {...modeledData} />;
    case KENTICO_TYPES.AWARD:
      modeledData = Models.AwardModel.create(linkedItem as IAward);
      return <Award {...modeledData} />;
    case KENTICO_TYPES.CAREER_HERO:
      modeledData = Models.CareerHeroModel.create(linkedItem as ICareerHero);
      return <MainHero {...modeledData} careerHero={true} />;
    case KENTICO_TYPES.ACTIVE_JOB_OFFERTS:
      modeledData = Models.ActiveJobOffertsModel.create(
        linkedItem as IActiveJobOfferts
      );
      return (
        <ActiveJobOfferts
          {...modeledData}
          jobOffersElevato={jobOffersElevato}
        />
      );
    case KENTICO_TYPES.PROCESS_BOXES:
      modeledData = Models.ProcessBoxesModel.create(
        linkedItem as IProcessBoxes
      );
      return <ProcessBoxes {...modeledData} />;
    case KENTICO_TYPES.VIDEO_LIST:
      modeledData = Models.VideoListModel.create(linkedItem as IVideoList);
      return <VideoList {...modeledData} />;
    case KENTICO_TYPES.CTA_BUTTON:
      modeledData = Models.CtaButtonModel.create(linkedItem as ICTAButtonData);
      return <CTAButton {...modeledData} />;
    case KENTICO_TYPES.HIGHLIGHTED_FIELD:
      modeledData = Models.HighlightedFieldModel.create(
        linkedItem as IHightlightedFieldData
      );
      return <HighlightedField {...modeledData} />;
    case KENTICO_TYPES.EMBEDEDDED_VIDEO:
      modeledData = Models.EmbededdedVideoModel.create(
        linkedItem as IEmbeddedVideoData
      );
      return <EmbeddedVideo {...modeledData} />;
    default:
      return null;
  }
};

export default Section;
